(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-instagram-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-instagram-reels')) {
    customElements.define('sc-instagram-reels', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.rail = this.querySelector('[data-sc-instagram-rail]');
        this.cards = [...this.querySelectorAll('[data-sc-instagram-card]')];
        this.previousButton = this.querySelector('[data-sc-instagram-previous]');
        this.nextButton = this.querySelector('[data-sc-instagram-next]');

        this.previousButton?.addEventListener('click', () => this.scrollRail(-1));
        this.nextButton?.addEventListener('click', () => this.scrollRail(1));
        this.rail?.addEventListener('scroll', () => this.updateNavigation(), { passive: true });
        window.addEventListener('resize', () => this.updateNavigation(), { passive: true });

        this.setupMotion();
        this.observeIframes();
        this.observeSection();
        this.observeReveal();
        this.updateNavigation();
      }

      setupMotion() {
        const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          this.classList.add('is-visible');
          return;
        }
        this.classList.add('is-motion-ready');
      }

      observeSection() {
        if (!('IntersectionObserver' in window)) {
          this.loadEmbeds();
          return;
        }

        this.sectionObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.sectionObserver.disconnect();
          this.loadEmbeds();
        }, { rootMargin: '360px 0px', threshold: 0.01 });

        this.sectionObserver.observe(this);
      }

      observeReveal() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.revealObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.revealObserver.disconnect();
          window.requestAnimationFrame(() => this.classList.add('is-visible'));
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

        this.revealObserver.observe(this);
      }

      observeIframes() {
        const bindIframes = () => {
          this.querySelectorAll('[data-sc-instagram-frame]').forEach((frame) => {
            const iframe = frame.querySelector('iframe');
            if (!iframe || frame.scInstagramIframe === iframe) return;
            frame.scInstagramIframe = iframe;

            let fallbackTimer;
            const reveal = () => {
              if (frame.dataset.instagramRevealQueued === 'true') return;
              frame.dataset.instagramRevealQueued = 'true';
              window.clearTimeout(fallbackTimer);
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                  frame.classList.add('is-ready');
                  frame.setAttribute('aria-busy', 'false');
                });
              });
            };

            iframe.addEventListener('load', reveal, { once: true });
            fallbackTimer = window.setTimeout(reveal, 1400);
          });
        };

        this.frameObserver = new MutationObserver(bindIframes);

        this.frameObserver.observe(this, { childList: true, subtree: true });
        bindIframes();
      }

      loadEmbeds() {
        if (this.dataset.embedsRequested === 'true') return;
        this.dataset.embedsRequested = 'true';

        this.loadInstagramScript()
          .then(() => {
            window.instgrm?.Embeds?.process();
            window.setTimeout(() => {
              this.querySelectorAll('[data-sc-instagram-frame]').forEach((frame) => {
                if (frame.classList.contains('is-ready')) return;
                frame.classList.add('has-error');
                frame.setAttribute('aria-busy', 'false');
              });
            }, 10000);
          })
          .catch(() => {
            this.querySelectorAll('[data-sc-instagram-frame]').forEach((frame) => {
              frame.classList.add('has-error');
              frame.setAttribute('aria-busy', 'false');
            });
          });
      }

      loadInstagramScript() {
        if (window.instgrm?.Embeds) return Promise.resolve();
        if (window.scInstagramEmbedPromise) return window.scInstagramEmbedPromise;

        window.scInstagramEmbedPromise = new Promise((resolve, reject) => {
          let script = document.querySelector('script[src*="instagram.com/embed.js"]');
          const timeout = window.setTimeout(() => reject(new Error('Instagram embed timeout')), 12000);
          const complete = () => {
            window.clearTimeout(timeout);
            resolve();
          };
          const fail = () => {
            window.clearTimeout(timeout);
            reject(new Error('Instagram embed unavailable'));
          };

          if (!script) {
            script = document.createElement('script');
            script.src = 'https://www.instagram.com/embed.js';
            script.async = true;
            script.defer = true;
            script.dataset.scInstagramScript = 'true';
            document.body.appendChild(script);
          }

          script.addEventListener('load', complete, { once: true });
          script.addEventListener('error', fail, { once: true });
          if (window.instgrm?.Embeds) complete();
        });

        return window.scInstagramEmbedPromise;
      }

      scrollRail(direction) {
        const card = this.cards[0];
        if (!this.rail || !card) return;
        const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap || getComputedStyle(this.rail).gap) || 12;
        this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateNavigation() {
        if (!this.rail || !this.previousButton || !this.nextButton) return;
        const hasOverflow = this.rail.scrollWidth > this.rail.clientWidth + 2;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        if (!hasOverflow) return;
        this.previousButton.disabled = this.rail.scrollLeft <= 2;
        this.nextButton.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-instagram-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-instagram-video')) {
    customElements.define('sc-instagram-video', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-sc-instagram-rail]');
        this.cards = [...this.querySelectorAll('[data-sc-instagram-card]')];
        this.previousButton = this.querySelector('[data-sc-instagram-previous]');
        this.nextButton = this.querySelector('[data-sc-instagram-next]');
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.saveData = navigator.connection?.saveData === true;

        this.cards.forEach((card) => {
          const video = card.querySelector('[data-sc-instagram-media]');
          const toggle = card.querySelector('[data-sc-instagram-toggle]');
          const sound = card.querySelector('[data-sc-instagram-sound]');

          toggle?.addEventListener('click', () => this.togglePlayback(card, video, toggle));
          sound?.addEventListener('click', () => this.toggleSound(card, video, sound));
          video?.addEventListener('play', () => this.syncPlayingState(card, toggle, true));
          video?.addEventListener('pause', () => this.syncPlayingState(card, toggle, false));
        });

        this.previousButton?.addEventListener('click', () => this.scrollRail(-1));
        this.nextButton?.addEventListener('click', () => this.scrollRail(1));
        this.rail?.addEventListener('scroll', () => this.updateNavigation(), { passive: true });
        window.addEventListener('resize', this.updateNavigationBound = () => this.updateNavigation(), { passive: true });

        this.observeSection();
        requestAnimationFrame(() => this.updateNavigation());
      }

      disconnectedCallback() {
        this.sectionObserver?.disconnect();
        window.removeEventListener('resize', this.updateNavigationBound);
      }

      hydrate(video) {
        if (!video || video.dataset.hydrated === 'true') return;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.dataset.hydrated = 'true';
        video.load();
      }

      pauseOthers(activeVideo) {
        this.cards.forEach((card) => {
          const video = card.querySelector('[data-sc-instagram-media]');
          if (video && video !== activeVideo) video.pause();
        });
      }

      async play(card, video) {
        if (!video) return;
        this.hydrate(video);
        this.pauseOthers(video);
        try {
          await video.play();
          card.classList.add('is-featured');
          this.cards.filter((item) => item !== card).forEach((item) => item.classList.remove('is-featured'));
        } catch (error) {
          card.classList.remove('is-playing');
        }
      }

      togglePlayback(card, video) {
        if (video.paused) {
          this.play(card, video);
        } else {
          video.pause();
        }
      }

      toggleSound(card, video, button) {
        if (!video) return;
        video.muted = !video.muted;
        const hasSound = !video.muted;
        card.classList.toggle('has-sound', hasSound);
        button.setAttribute('aria-pressed', String(hasSound));
        button.setAttribute('aria-label', hasSound ? 'Disattiva audio' : 'Attiva audio');
      }

      syncPlayingState(card, button, isPlaying) {
        card.classList.toggle('is-playing', isPlaying);
        button?.setAttribute('aria-pressed', String(isPlaying));
        button?.setAttribute('aria-label', `${isPlaying ? 'Metti in pausa' : 'Riproduci'} ${card.querySelector('video')?.getAttribute('aria-label') || 'video'}`);
      }

      observeSection() {
        if (!('IntersectionObserver' in window)) return;
        this.sectionObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry?.isIntersecting) {
            this.cards.forEach((card) => card.querySelector('video')?.pause());
            return;
          }

          const featuredCard = this.cards.find((card) => card.dataset.featured === 'true') || this.cards[0];
          if (window.matchMedia('(max-width: 749px)').matches) {
            featuredCard?.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
          }

          if (this.dataset.autoplay === 'true' && !this.prefersReducedMotion && !this.saveData) {
            this.play(featuredCard, featuredCard?.querySelector('[data-sc-instagram-media]'));
          }
        }, { rootMargin: '180px 0px', threshold: 0.2 });
        this.sectionObserver.observe(this);
      }

      scrollRail(direction) {
        const card = this.cards[0];
        if (!this.rail || !card) return;
        const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap || getComputedStyle(this.rail).gap) || 12;
        this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.prefersReducedMotion ? 'auto' : 'smooth' });
      }

      updateNavigation() {
        if (!this.rail || !this.previousButton || !this.nextButton) return;
        const hasOverflow = this.rail.scrollWidth > this.rail.clientWidth + 2;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        if (!hasOverflow) return;
        this.previousButton.disabled = this.rail.scrollLeft <= 2;
        this.nextButton.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-pdp-antonello"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-pdp-person')) {
    class ScPdpPerson extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.dataset.ready = 'true';

        this.video = this.querySelector('[data-sc-person-video]');
        this.source = this.video?.querySelector('source[data-src]');
        this.playButton = this.querySelector('[data-sc-person-play]');
        this.soundButton = this.querySelector('[data-sc-person-sound]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.saveData = Boolean(navigator.connection?.saveData);

        this.playButton?.addEventListener('click', () => this.togglePlayback());
        this.soundButton?.addEventListener('click', () => this.toggleSound());
        this.video?.addEventListener('play', () => this.updateState());
        this.video?.addEventListener('pause', () => this.updateState());
        this.video?.addEventListener('volumechange', () => this.updateState());

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this.loadVideo();
              if (this.dataset.autoplay === 'true' && !this.reduceMotion && !this.saveData) {
                this.video?.play().catch(() => this.updateState());
              }
            } else if (entry.boundingClientRect.top < 0 || entry.boundingClientRect.top > window.innerHeight) {
              this.video?.pause();
            }
          });
        }, { rootMargin: '180px 0px', threshold: 0.22 });

        this.observer.observe(this);
        this.updateState();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      loadVideo() {
        if (!this.source?.dataset.src) return;
        this.source.src = this.source.dataset.src;
        this.source.removeAttribute('data-src');
        this.video.load();
      }

      togglePlayback() {
        if (!this.video) return;
        this.loadVideo();
        if (this.video.paused) {
          this.video.play().catch(() => this.updateState());
        } else {
          this.video.pause();
        }
      }

      toggleSound() {
        if (!this.video) return;
        this.loadVideo();
        this.video.muted = !this.video.muted;
        if (this.video.paused) this.video.play().catch(() => this.updateState());
        this.updateState();
      }

      updateState() {
        const isPlaying = Boolean(this.video && !this.video.paused);
        const hasSound = Boolean(this.video && !this.video.muted);
        this.classList.toggle('is-playing', isPlaying);
        this.classList.toggle('has-sound', hasSound);

        if (this.playButton) {
          this.playButton.setAttribute('aria-pressed', String(isPlaying));
          this.playButton.setAttribute('aria-label', isPlaying ? this.dataset.pauseLabel : this.dataset.playLabel);
        }

        if (this.soundButton) {
          this.soundButton.setAttribute('aria-pressed', String(hasSound));
          this.soundButton.setAttribute('aria-label', hasSound ? this.dataset.soundOffLabel : this.dataset.soundOnLabel);
        }
      }
    }

    customElements.define('sc-pdp-person', ScPdpPerson);
  }

  } catch(e) { console.error(e); }
})();
})();
